import styled from 'styled-components';
import { RefreshButton, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { DiscardedEmptyState } from 'ui/illustrations';
import { useTranslations } from '../../../hooks/useTranslations';

type Props = {
  refresh: () => void;
  isRefreshing: boolean;
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: ${({ theme }) => theme.spacing.values.x10};
`;

const Title = styled.div`
  ${({ theme }) => theme.styles.headings.heading4};
  font-size: ${({ theme }) => theme.styles.fontSizes.s18};
  padding: ${({ theme }) => theme.spacing.values.threeQuarter};
`;

const Description = styled.div`
  ${({ theme }) => theme.styles.body.body2};
  align-items: center;
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing.values.threeQuarter};
`;

const StyledRefreshButton = styled(RefreshButton)`
  flex-direction: row;
  column-gap: 0;
`;

export const ErrorMessage = ({ refresh, isRefreshing }: Props) => {
  const { t } = useTranslations();
  const loadingMessage = isRefreshing
    ? t('errors.errorBoundary.loading')
    : t('errors.errorBoundary.refresh');

  return (
    <Wrapper>
      <DiscardedEmptyState />
      <Title>{t('errors.errorBoundary.title')}</Title>
      <Description>
        <div>{t('errors.errorBoundary.subtitle')}</div>
        <div>{t('errors.errorBoundary.description')}</div>
      </Description>
      <StyledRefreshButton
        onClick={refresh}
        isRefreshing={isRefreshing}
        isDisabled={isRefreshing}
        variant={BUTTON_VARIANTS.PRIMARY}
        size={BUTTON_SIZES.MEDIUM}
      >
        {loadingMessage}
      </StyledRefreshButton>
    </Wrapper>
  );
};
